import React, { useState } from "react";
import { CardImg, UncontrolledTooltip } from "reactstrap";
import {
  Card,
  CardImgContainer,
  CardProductCode,
  CardProductName,
} from "./style";

const Catalog = (props) => {
  const [copiedId, setCopiedId] = useState(null);

  return (
    <>
      <UncontrolledTooltip target={`catalog_${props.sku}`} placement="bottom">
        Click to copy the SKU
      </UncontrolledTooltip>
      <div
        className="col-6 col-sm-4 col-md-3 col-xl-2"
        id={`catalog_${props.sku}`}
        onClick={() => {
          navigator.clipboard.writeText(props.sku || props.id);
          setCopiedId(props.id);

          setTimeout(() => {
            setCopiedId(null);
          }, 5000);
        }}
      >
        <Card className="module-card">
          <CardImgContainer>
            <CardImg
              className="object-fit-contain"
              src={props.images[0]}
              alt={props.name}
            />
          </CardImgContainer>
          <div className="pt-2 d-flex flex-column row-gap-1">
            <CardProductCode className="text-black">{props.sku}</CardProductCode>
            <CardProductName title={props.name}>{props.name}</CardProductName>
          </div>
          {copiedId === props.id && <div className="copied-text"> SKU copied</div>}
        </Card>
      </div>
    </>
  );
};

export default Catalog;
